define('plugin/membership/model/ClientMembershipModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Client Membership data model
     *
     * @class ClientMembershipModel
     */
    return BaseModel.extend({

        defaults: {
            id: '',
            name: '',
            description: '',
            first_price: 0,
            recurring_price: 0,
            duration: 1,
            duration_type: 'month',
            is_active: 1,
            position: 0,
            file_id: null,

            membership: null
        },

        toJSON: function () {
			var result = BaseModel.prototype.toJSON.apply(this, arguments);

            //NB copied from IndexService::getClientMembershipList()
            if (result.membership) {
                for (var i in result.membership) {
                    if (i != 'id') {
                        result[i] = result.membership[i];
                    }
                }
            }

            result.picture_path = result.picture_preview;
            result.picture = result.picture_preview;
            result.is_active = ~~result.is_active;
            result.is_visible = ~~result.is_visible;
            result.recurring_status = result.recurring_profile_status;

            //TODO is this required? Where do I get it?
            // result.next_payment_date

            return result;
        }

    });

});
